import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TriangleWarning } from "components/icons/TriangleWarning";
import React from "react";
import { ModalProps } from "types/utils/modal";

export const DeleteEntityConfirmation = ({
  isOpen,
  close,
  onClick,
}: ModalProps & { onClick: () => void }) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content size="small">
      <Modal.Body>
        <div>
          <span className="t-text-orange t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255,220,78,0.15)] t-border t-border-orange-20 t-border-solid t-bg-yellow-20">
            <TriangleWarning />
          </span>
          <p className="t-mb-2 t-text-subtext t-mt-5">Delete this entity?</p>
          <div className="t-text-body-sm t-text-text-30">
            You’ll lose all saved information for this entity.
          </div>
        </div>
      </Modal.Body>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button>Cancel</Button>
        </Modal.RawClose>
        <Button customType="primary" onClick={onClick}>
          Yes, delete
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
